import {Alert, FormControlLabel, Grid, Switch, Typography} from "@mui/material";
import {LChart, LChartSeries, LineChart} from "../../../components/chart/line_chart";
import React, {useState} from "react";
import {ManagerStats} from "arteco-api-client-ts";
import {colors} from "../../../components/utils/colors";

export interface EmpProductivityChartProps {
	stats: ManagerStats;
}

export const EmpProductivityChart = ({stats}: EmpProductivityChartProps) => {
	const [accumulated, setAccumulated] = useState<boolean>(true);

	const lineChart = (stats: ManagerStats): LChart => {
		const xAxisData: string[] = [];
		let i = 0;
		const seriesData: LChartSeries[] = [
			{label: "Totales", color: colors[i++ % colors.length], values: []},
			{label: "Time & Materials", color: colors[i++ % colors.length], values: []},
			{label: "Asignada a Presupuesto", color: colors[i++ % colors.length], values: []},
			{label: "Sin Asignar", color: colors[i++ % colors.length], values: []}
		];

		let prevWorked = 0;
		let prevBudget = 0;
		let prevTm = 0;
		let prevSin = 0;

		stats.months?.map((x) => {
			xAxisData.push(x.year + "-" + x.month);
			if (accumulated) {
				prevWorked += x.dedication?.workedHours || 0;
				prevBudget += x.dedication?.budgetHours || 0;
				prevTm += x.dedication?.tmHours || 0;
				prevSin += x.dedication?.unassignedHours || 0;
				seriesData[0].values.push(prevWorked);
				seriesData[1].values.push(prevTm);
				seriesData[2].values.push(prevBudget);
				seriesData[3].values.push(prevSin);
			} else {
				seriesData[0].values.push(x.dedication?.workedHours || 0);
				seriesData[1].values.push(x.dedication?.tmHours || 0);
				seriesData[2].values.push(x.dedication?.budgetHours || 0);
				seriesData[3].values.push(x.dedication?.unassignedHours || 0);
			}
		});

		return {
			xAxisData,
			seriesData
		}
	}



	return (
		<>
			<Grid container sx={{mt: 4}}>
				<Grid item xs>

					<Typography variant="h6" color="textSecondary">
						HORAS DEDICADAS DEL EQUIPO
					</Typography>

					<Alert sx={{my: 2}} color="info">
						Total de horas <b>dedicadas</b> de todos los miembros del equipo importadas de Redmine
						vía el Responsable. <br/>En su defecto, se coge la asignación de la Extranet,
						al igual que las vacaciones.
						{/*
								Las <b>presupuestadas</b> salen de prorratear las horas totales entre las fechas de
								inicio y fin.
								*/}
					</Alert>
				</Grid>
				<Grid item xs={2} textAlign="center">
					<br/>
					<br/>
					<br/>
					<FormControlLabel labelPlacement={"start"}
									  control={<Switch checked={accumulated}
													   onChange={(e, v) => {
														   setAccumulated(v);
													   }}/>} label={accumulated ? "Acumulado" : "Mensual"}/>
				</Grid>
			</Grid>

			<LineChart data={lineChart(stats)}/>
		</>
	)
}